// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"d64b6a44","419":"c4ba488e","453":"8701dc61","473":"608f1f17","568":"b371a33c","637":"59d9c533"}[chunkId] + ".chunk.js";
};